import { mapGetters } from 'vuex'
import {handleContractAttrs, isIllegalityValue} from '../utils'
import { GENERATE_CONTRACT_CHILD} from '../constants'

// contract_types
export const contract_types_mixins = {
    data() {
        return {
        
        }
    },
    computed: {
        ...mapGetters({
            contract_types: 'async/contract_types',
          }),
          contract_types_all_hash() {
           return handleContractAttrs(this.contract_types)
          } 
    }

}

export const common_mixins = {
    props: {
        value: {
            type: Object,
        },
    },
    computed: {
        ...mapGetters({
            contract_types: 'async/contract_types',
          }),
          is_generate_from_contract_child() {
            return this.params._contract_generate_type === GENERATE_CONTRACT_CHILD
        },
    },
    data() {
        return {
            params: this.value,
        }
    },
    watch: {
        params(new_val) {
            this.$emit('input', new_val)
        },
        value(new_val) {
            this.params = new_val
        },
    },
    methods: {
        validate() {
           return this.$refs.base && this.$refs.base.validate && this.$refs.base.validate()
        },
        resetValidation() {
            return this.$refs.base && this.$refs.base.resetValidation && this.$refs.base.resetValidation()
        }
    },
}

export const stock_mixins = {
    methods: {
        getParentTotal() {
            let total_price = null
            this.params && this.params.contract_stock_parts && this.params.contract_stock_parts.forEach(item => {
                total_price = math.eval(`${total_price}+${item.total_price}`)
             })
             if (isIllegalityValue(total_price)) {
                this.params.contract_stocks[0].total_price = null
                return 
             }
             this.params.contract_stocks[0].total_price = Number(total_price.toFixed(2))
             this.setUnitPrice(this.params.contract_stocks[0])
        },  
        setUnitPrice(target) {
            if (isIllegalityValue(target.qty) || isIllegalityValue(target.total_price)) {
                target.unit_price = null
                return
            }
            let unit_price = target.total_price / target.qty
            unit_price = unit_price.toFixed(6)
            unit_price = Number(unit_price)
            target.unit_price = unit_price
        },
    }
}